// @flow

import styled from "styled-components";
import buildColor from "../../_static/ColorPalette";
import { buildText } from "../../_atom/Text";
import Icon from "../../_static/Icons";
import { fontMedium } from "../../_static/Typography";

export const AmountSelectorContainer = styled.div`
  width: 120px;
  height: 40px;
  overflow: hidden;
  flex: 0 0 auto;
  margin: 0 8px;
  border: 1px solid ${buildColor("grey", "300")};
  border-radius: 2px;
  position: relative;
`;

export const AmountLabelsWrapper = styled.span`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 6px 32px 6px 8px;
`;

export const AmountValue = styled(
  buildText({
    tag: "span",
    fontSize: 14,
    color: buildColor("grey", "900"),
    uppercase: true,
    ellipsis: true
  })
)`
  font-family: ${fontMedium};
`;

export const SelectIcon = styled(Icon)`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translate(0, -50%);
`;

export const SelectList = styled.select.attrs({
  "data-qa-label": "betTicket-amountSelector"
})`
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;
